/**
 * Horizontal distribution row — port of MAFA's `DistRow` from ui.jsx.
 * Renders a labelled progress-style bar with a percentage and count.
 */

type Props = {
  label: string;
  count: number;
  total: number;
  accent?: boolean;
};

export function DistRow({ label, count, total, accent }: Props) {
  const pct = total > 0 ? Math.round((count / total) * 100) : 0;
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
        <span className={'meta' + (accent ? ' acc' : '')}>
          <span className="sq" />
          {label}
        </span>
        <span style={{ fontWeight: 700, fontSize: 12.5, fontVariantNumeric: 'tabular-nums' }}>
          {count.toLocaleString('fr-FR')}{' '}
          <span className="muted" style={{ fontWeight: 600 }}>· {pct}%</span>
        </span>
      </div>
      <div className="progress">
        <div className="fill" style={{ width: pct + '%' }} />
      </div>
    </div>
  );
}
